/**
 * Visible boot/error overlay. Phase 0 keeps it simple: one panel that can
 * carry a title and a detail line. Every WebGPU failure path goes through
 * here so we never end up with a silent black canvas.
 */

const ROOT_ID = 'boot-message';

function el(): HTMLElement {
  const root = document.getElementById(ROOT_ID);
  if (!root) throw new Error(`#${ROOT_ID} missing from DOM`);
  return root;
}

export function showError(title: string, detail: string): void {
  const root = el();
  const panel = root.querySelector('.panel');
  if (!panel) return;
  const h1 = panel.querySelector('h1');
  const detailNode = panel.querySelector('#boot-detail');
  if (h1) h1.textContent = title;
  if (detailNode) detailNode.textContent = detail;
  root.classList.remove('hidden');
}

export function hideError(): void {
  el().classList.add('hidden');
}
